import React from 'react';
import { useObservable } from 'react-use-observable';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Divider, Row, Col, Tooltip } from 'antd';

import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import chargebackService from 'v2/services/chargeback';

import ExportChargeback from './Export';

const Totalizers = () => {
  const [totalItems] = useObservable(() => chargebackService.getTotalItems(), []);
  const [isLoading] = useObservable(() => chargebackService.isLoading(), []);
  const [getTotalChargeback] = useObservable(() => chargebackService.getTotalChargeback(), []);

  const chargebacksCount = `${totalItems} Chargeback${totalItems > 1 ? 's' : ''}`;

  if (isLoading) return null;

  return (
    <Row
      id='chargebacks-totalizers'
      className='mb-4 w-full rounded-sm bg-white shadow-[0_1px_0_0_rgba(0,0,0,0.07)]'
      align='middle'
    >
      <Col>
        <div className='px-4 py-2'>
          <span className='flex items-center gap-1 text-base font-semibold'>{chargebacksCount}</span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <Col>
        <div className='px-4 py-2'>
          <span className='flex items-center gap-1 text-base font-semibold'>
            <span>Total de Chargeback:</span> <ColoredFormattedNumber value={getTotalChargeback} format='BRL' />
            <Tooltip title='Valor total das faturas em chargeback' placement='rightTop'>
              <QuestionCircleOutlined style={{ fontSize: 16 }} />
            </Tooltip>
          </span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <Col className='ml-auto'>
        <ExportChargeback />
      </Col>
    </Row>
  );
};

export default Totalizers;
